import "./home.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

// Image imports
import WebsiteSmall from "../../assets/mikeBattery-small.png"; // 300px
import WebsiteMedium from "../../assets/mikeBattery-medium.png"; // 600px
import WebsiteLarge from "../../assets/mikeBattery-large.png"; // 900px
import jimsAIImages from "../../assets/jimsAIImages.jpeg"; // Add variants as needed
import oldPortfolio from "../../assets/portfolioRonBusnardo.png";
import eCommerce from "../../assets/E-Commerce.png";
import tardCityTutoring from "../../assets/tardCityTutoring.png";
import bigSkyREMF from "../../assets/bigSkyREMF.png";
import ReactIcon from "../../assets/react.svg";
import CSS3 from "../../assets/CSS3.webp";
import Firebase from "../../assets/Firebase.webp";
import CSharp from "../../assets/CSharp.webp";
import HTML from "../../assets/HTML.webp";
import SQL from "../../assets/SQL.webp";
import Supabase from "../../assets/supabase.png";
import GitHub from "../../assets/gitHub.png";

const Home = () => {
  const skills = [
    { src: ReactIcon, name: "React", alt: "React logo" },
    { src: CSS3, name: "CSS3", alt: "CSS3 logo" },
    { src: Firebase, name: "Firebase", alt: "Firebase logo" },
    { src: CSharp, name: "C#", alt: "C# logo" },
    { src: HTML, name: "HTML", alt: "HTML logo" },
    { src: SQL, name: "SQL", alt: "SQL logo" },
    { src: Supabase, name: "Supabase", alt: "Supabase logo" },
    { src: GitHub, name: "GitHub", alt: "GitHub logo" },
  ];

  const projects = [
    {
      url: "https://mikebatteryfirebase.vercel.app/",
      image: WebsiteMedium, // Default image
      srcSet: `${WebsiteSmall} 300w, ${WebsiteMedium} 600w, ${WebsiteLarge} 900w`,
      sizes: "(max-width: 600px) 300px, (max-width: 900px) 600px, 900px",
      alt: "Mike Battery Promotion Tracker",
      title: "Marine Promotion Tracker",
      description:
        "Website used to track Marines eligible for meritorious promotion. Features sorting by section, rank, MOS, etc. Built with React.js and Firebase backend.",
    },
    {
      url: "https://marnoldarnold.vercel.app/",
      image: jimsAIImages,
      alt: "AI Images Website",
      title: "AI Images Showcase",
      description:
        "Website featuring AI-generated images. Built with React.js, CSS3, and Supabase backend.",
    },
    {
      url: "https://ronbusnardo.vercel.app/",
      image: oldPortfolio,
      alt: "Personal Portfolio V1",
      title: "First Portfolio",
      description:
        "Initial personal website attempt using React.js and Tailwind CSS. No backend implementation.",
    },
    {
      url: "https://velvety-cannoli-2a136e.netlify.app/",
      image: eCommerce,
      alt: "E-Commerce Demo",
      title: "E-Commerce Store",
      description:
        "Udemy project featuring a basic e-commerce website with Stripe payment processing. Uses CSS components.",
    },
    {
      url: "https://tardcitycollege.netlify.app/",
      image: tardCityTutoring,
      alt: "Tard City Tutoring Website",
      title: "Tutoring Website",
      description:
        "Website designed for a personal tutor. Features appointment setup design without backend implementation.",
    },
    {
      url: "https://big-sky-remf.vercel.app/",
      image: bigSkyREMF,
      alt: "Big Sky REMF Website",
      title: "CSS Experiment Website",
      description:
        "Experimental website created to explore CSS techniques, combining tutorial elements with custom styles.",
    },
  ];

  return (
    <div className="home-container">
      <section className="welcome-section" aria-labelledby="welcome-heading">
        <h1 id="welcome-heading">Ron Busnardo</h1>
        <h2>Full Stack Developer</h2>
        <p>Bozeman's most "okay-ish" Full Stack Developer</p>
      </section>

      <section className="about-section" aria-labelledby="about-heading">
        <h2 id="about-heading">About Me</h2>
        <p>I am a Full Stack Developer with experience in the following areas:</p>
        <ul className="skills-list" aria-label="Technical skills">
          {skills.map((skill, index) => (
            <li key={`skill-${index}`}>
              <LazyLoadImage
                src={skill.src}
                alt={skill.alt}
                className="skill-list-icons"
                effect="blur"
                height="50"
                width="50"
              />
            </li>
          ))}
        </ul>
      </section>

      <div className="project-sections-container" aria-labelledby="projects-heading">
        <h2 id="projects-heading" className="visually-hidden">Projects</h2>
        {projects.map((project, index) => (
          <section
            key={`project-${index}`}
            className="portfolio-section glass-effect"
            aria-labelledby={`project-title-${index}`}
          >
            <div className="project">
              <a
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit ${project.title}`}
              >
                <LazyLoadImage
                  src={project.image}
                  alt={project.alt}
                  className="img-project"
                  effect="blur"
                  height="150"
                  width="300"
                />
              </a>
              <div className="project-description">
                <h3 id={`project-title-${index}`}>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Home;